import { render } from "./mga-page.vue?vue&type=template&id=0b0ca5c7&ts=true"
import script from "./mga-page.ts?vue&type=script&lang=ts"
export * from "./mga-page.ts?vue&type=script&lang=ts"

import "./mga-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__